import { ExploreTestID, TextTestID } from "@/constants/TestID";
import { IllustrationSize } from "@/constants/UI";
import Text from "@/ui/core/Text";
import TextTag from "@/ui/core/TextTag";
import { BaseCard, Box, HStack, VStack } from "@/ui/layout";
import { getIllustrationIcon } from "@/ui/theme/icons/illustrations/groupClasses";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface GroupClassSeriesPreviewCardProps {
  groupClassExternalId: string;
  iconName: string;
  isUserRegistered?: boolean;
  onSelect: (groupClassExternalId: string) => void;
  recurrenceString: string;
  timeRange: string;
  title: string;
}

const enum PreviewCardSize {
  Height = 168,
  Width = 200,
}

const GroupClassSeriesPreviewCard = ({
  groupClassExternalId,
  iconName,
  isUserRegistered,
  onSelect,
  recurrenceString,
  timeRange,
  title,
}: GroupClassSeriesPreviewCardProps) => {
  const IllustrationIcon = getIllustrationIcon({
    height: IllustrationSize.PreviewCard,
    iconName,
    width: IllustrationSize.PreviewCard,
  });

  const baseTestID = joinTestIDs(
    groupClassExternalId,
    ExploreTestID.GroupClassSeriesPreviewCard,
  );

  return (
    <BaseCard
      maxHeight={PreviewCardSize.Height}
      maxWidth={PreviewCardSize.Width}
      onPress={() => onSelect(groupClassExternalId)}
      testID={baseTestID}
    >
      <VStack gap={12}>
        <HStack alignItems="center" justifyContent="space-between">
          {IllustrationIcon}
          {isUserRegistered && (
            <Box>
              <TextTag text="Registered" />
            </Box>
          )}
        </HStack>
        <VStack gap={4}>
          <Box height={42}>
            <Text
              numberOfLines={2}
              testID={joinTestIDs(baseTestID, TextTestID.Title)}
              variant="bodyMedium"
            >
              {title}
            </Text>
          </Box>
          <Text
            color={ColorToken.NeutralSecondary}
            numberOfLines={1}
            testID={joinTestIDs(baseTestID, ExploreTestID.RecurrenceString)}
            variant="caption"
          >
            {recurrenceString}
          </Text>
          <Text
            color={ColorToken.NeutralSecondary}
            numberOfLines={1}
            testID={joinTestIDs(baseTestID, ExploreTestID.TimeRange)}
            variant="caption"
          >
            {timeRange}
          </Text>
        </VStack>
      </VStack>
    </BaseCard>
  );
};

export type { GroupClassSeriesPreviewCardProps };
export { PreviewCardSize };
export default GroupClassSeriesPreviewCard;
